import { TestIframe } from '../TestIframe/TestIframe';
import { CertificateCard } from 'components/CertificateCard/CertificateCard';
import { LoadingPlaceholder } from '@trackman/web-shared-components';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useServices } from 'index';
import { useEffect } from 'react';

type CertificationExamProps = {
  title: string;
  isCompleted: boolean;
  certificationId: string;
  moduleId: string;
  progress: number;
  badgeImageUrl: string;
};

export const CertificationExam = ({ title, isCompleted, certificationId, moduleId, progress, badgeImageUrl }: CertificationExamProps) => {
  const queryClient = useQueryClient();
  const service = useServices().learningHubService;

  const testContent = useQuery({
    queryKey: ['learningHubTestContent', certificationId],
    queryFn: () => service.getLearningHubTestContent(certificationId),
    refetchOnWindowFocus: false,
    gcTime: 0,
  });

  useEffect(
    () => () => {
      if (!isCompleted) {
        queryClient.invalidateQueries({ queryKey: ['moduleContents', moduleId] });
      }
    },
    []
  );

  return (
    <>
      {!testContent.isPending ? (
        !isCompleted ? (
          <TestIframe area9LaunchUrl={testContent.data.launchUrl} lessonParams={testContent.data.parameters} />
        ) : (
          <CertificateCard title={title} status='Completed' description='' prerequisites={[]} progress={progress} badgeImageUrl={badgeImageUrl} />
        )
      ) : (
        <LoadingPlaceholder />
      )}
    </>
  );
};
